<template>
  <div class="parent">
    <v-card class="top-row py-2 px-3" elevation="2">
      <v-text-field
        class="search-field"
        label="Sök efter nyheter"
        prepend-inner-icon="mdi-magnify"
        clearable
        outlined
        dense
        hide-details="true"
        @input="onSearch"
        :value="searchTerm"
      ></v-text-field>
      <v-btn size="large" color="primary" :to="{ name: 'createNews' }"> Skapa nyhet </v-btn>
    </v-card>

    <div class="list mt-3">
      <div class="online">
        <LatestNews
          label="Publicerade"
          :loading="loading"
          :items="online"
          :meta="meta"
          @news:goto="onClickNews"
        >
          <template #pagination><Pagination v-bind="meta" @change="onPagination" /> </template>
        </LatestNews>
      </div>
      <div class="offline">
        <LatestNews label="Utkast" :loading="loadingOffline" :items="offline" @news:goto="onClickNews" >
            <template #pagination><Pagination v-bind="metaOffline" @change="onPaginationOffline" /> </template>
        </LatestNews>
      </div>
    </div>
    <!-- <div class="pagination-container mt-3">
      <Pagination v-bind="meta" @change="onPagination" />
    </div> -->
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LatestNews from '../../components/news/LatestNews'
import Pagination from '@/components/shared/Pagination.vue'

let debounce = null

export default {
  name: 'NewsList',
  components: {
    LatestNews,
    Pagination,
  },
  props: {
    news: { type: Array, default: () => [] },
    meta: { type: Object },
    newsOffline: { type: Array, default: () => [] },
    metaOffline: { type: Object },
    loading: { type: Boolean },
    loadingOffline: { type: Boolean },
  },
  computed: {
    ...mapGetters('news', ['getFilters']),
    searchTerm() {
      return this.getFilters.find(f => f.key === 'news_title')?.value || ''
    },
    online() {
      return this.news
    },
    offline() {
      return this.newsOffline
    },
  },
  methods: {
    onSearch(val) {
      clearTimeout(debounce)
      debounce = setTimeout(() => {
      this.$emit('news:search', val)
      }, 600)
    },
    onClickNews({ id }) {
      this.$router.push({ name: 'SingleNews', params: { id } })
    },
    onPagination(val) {
      this.$emit('news:pagination', val)
    },
    onPaginationOffline(val) {
      this.$emit('news:pagination:offline', val)
    },
  },
}
</script>

<style lang="less" scoped>
.top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .search-field {
    max-width: 400px;
  }
}
.list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 15px;
  grid-row-gap: 0px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-right: -10px;
}
</style>
